export default "__VITE_ASSET__Ce06T$Ff__"